module.exports = __webpack_public_path__ + "static/media/p6.c5779301.jpg";